import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import {
  tripLoginModalSignUpDismiss,
  tripLoginModalSignUpView,
} from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import usePendingLoginHandler from 'hooks/usePendingLoginHandler'
import CopyTemplate from 'tripPlanner/components/TripModal/Templates/CopyTemplate'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { FullTrip } from 'tripPlanner/types/common'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${rem(24)} ${rem(40)};
  gap: ${rem(16)};
  border-top: 1px solid ${(props) => props.theme.palette.neutral.default.six};
`

interface Props {
  trip: FullTrip
}

const trackTripLoginModalSignUpView = () => {
  fireInteractionEvent(tripLoginModalSignUpView('save_curated_trip'))
}
const trackTripLoginModalSignUpDismiss = () => {
  fireInteractionEvent(tripLoginModalSignUpDismiss('save_curated_trip'))
}

export function ContinuePlanningBanner({ trip }: Props) {
  const openModal = useOpenModal()

  const copyTrip = useCallback(
    () =>
      openModal(CopyTemplate, {
        template: trip,
      }),
    [openModal, trip],
  )

  const onSaveClick = usePendingLoginHandler(
    copyTrip,
    'tripPlannerLogin',
    trackTripLoginModalSignUpView,
    trackTripLoginModalSignUpDismiss,
  )

  return (
    <Container>
      <Heading variant="heading4">
        Want to go on this trip? Start planning yours today!
      </Heading>

      <BodyText variant="medium">
        Make it your own by saving individual trip items or customising this
        entire trip below
      </BodyText>

      <TextButton kind="primary" onClick={onSaveClick}>
        Save Trip
      </TextButton>
    </Container>
  )
}
